import React, { useEffect, useState } from 'react';
//import logo from './logo.svg';
import './History.css';

import * as model from 'models';
import * as api from '../../lib/api';
import * as notifications from 'lib/notifications';
import { Atteststatus, Fakturastatus, Exportstatus, GenericSearchWrapper, SupplierInvoice, InvoiceSearchRequest, SupplierInvoiceImageResponse, SupplierInvoiceRow } from 'models/supplierinvoice';
import FmtDate, { formatDateAsYyyyMmDd } from 'components/Common/FmtDate';
import Amount from 'components/Common/Amount';
import { Charts, useJsRpcPlaner } from 'lib/jsRpcPlaner';
import { KonteringsOptions, ObjektTyp, useKonteringsOptions } from 'lib/useKonteringsOptions';
import { useInvoicePageState } from 'lib/useInvoicePageState';

interface IHistoryContainerProps {
  isOpen?: boolean;
  fakturaId: string;
  supplierId: number;
}

function HistoryContainer(props: IHistoryContainerProps) {
  console.log("HistoryContainer isOpen=", props.isOpen);

  const [pageDate, setPageData] = useState<GenericSearchWrapper<SupplierInvoice>>(null);
  const [invoice, setInvoice] = useState<SupplierInvoice>(null);
  const [onlyAttesterade, setonlyAttesterade] = useState<boolean>(true);
  const [onlyKonterade, setOnlyKonterade] = useState<boolean>(true);

  useEffect(() => {
    // Update the document title using the browser API
    if (props.isOpen) {
      refreshList();
    }
  }, [props.isOpen, onlyAttesterade, onlyKonterade]);

  function onClickSupplierItem(item: SupplierInvoice) {
    setInvoice(item);
  }

  return (
    <div className="modal fade supplierinvoice-history-modal" tabIndex={-1} role="dialog" id="react-supplierinvoice-history-container-modal">

      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="btn btn-primary" style={{ 'float': 'right' }} data-dismiss="modal">Stäng</button>
            {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> */}

            <h4 className="modal-title" id="myModalLabel">Historiska fakturor</h4>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-inline">
                      Visa endast:
                      <div className="checkbox">
                        <label className="" style={{"marginLeft": "10px"}}>
                          <input id="cbOnlyKonterade" type="checkbox" defaultChecked={onlyKonterade} onChange={(e) => setOnlyKonterade(!onlyKonterade)}/> Endast konterade</label>
                      </div>
                      <div className="checkbox">
                        <label className="" style={{"marginLeft": "10px"}}>
                          <input id="cbOnlyAttesterade" type="checkbox" defaultChecked={onlyAttesterade} onChange={(e) => setonlyAttesterade(!onlyAttesterade)}/> Endast attesterade</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <InvoiceTable pageDate={pageDate} clickItem={onClickSupplierItem} />
                  </div>
                  <div className="col-lg-12">
                    <InvoiceKonteringTable invoice={invoice} />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                {invoice ? <ImageWrapper invoiceId={invoice?.id} /> : <h4>Klicka på en rad för att visa fakturan!</h4>}
              </div>

            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" data-dismiss="modal">Stäng</button>
          </div>
        </div>
      </div>
    </div>


  );

  function refreshList() {
    let searchRequest = { sortColumn: "Id", sortAsc: false, komplettaFakturor: true, supplierIds: [props.supplierId] } as InvoiceSearchRequest;
    if (props.fakturaId) {
      searchRequest.fakturaIdSkip = [parseInt(props.fakturaId)];
    }
    if (onlyKonterade) {
      searchRequest.konterad = true;
    }

    if (onlyAttesterade) {
      searchRequest.attestStatusList = [Atteststatus.Ja];
    }

    api.supplierInvoiceSearch(searchRequest).then(data => {
      //console.log("got data", data);
      setPageData(data);
    }).catch((reason) => {
      //console.log("error", reason);
    });
  }
}

function ImageWrapper(props: { invoiceId?: number }) {
  if (!props.invoiceId)
    return null;

  const [pageIdx, setPageIdx] = useState<number>(0);
  const [imageData, setImageData] = useState<SupplierInvoiceImageResponse>(null);
  const imageUrl = api.supplierInvoiceImageGetUrl(props.invoiceId.toString(), pageIdx);

  useEffect(() => {
    // Update the document title using the browser API
    if (props.invoiceId) {
      setPageIdx(0);
      setImageData(null);
      api.supplierInvoiceImageGet(props.invoiceId).then(data => {
        setImageData(data);
      })
    }
  }, [props.invoiceId]);

  return (
    <>
      <div className="btn-toolbar">
        <div className="btn-group">
          <button type="button" className="btn btn-default" disabled={pageIdx <= 0} onClick={() => setPageIdx(Math.max(0, pageIdx - 1))}>« Föregående</button>
          <span className="btn btn-default disabled">Visar sida {pageIdx + 1} {imageData && ("/")} {imageData?.nrOfPages}</span>
          <button type="button" className="btn btn-default" disabled={pageIdx >= (imageData?.nrOfPages ?? 0) - 1} onClick={() => setPageIdx(Math.min(pageIdx + 1, imageData.nrOfPages - 1))}>Nästa »</button>
        </div>
      </div>

      <img src={imageUrl} className="img-responsive" />
    </>
  );
}

function InvoiceTable(props: { pageDate: GenericSearchWrapper<SupplierInvoice>, clickItem: (item: SupplierInvoice) => void }) {
  return <div className="table-responsive invoiceTableDiv">
    <table className="table table-striped table-condensed table-hover invoiceTable">
      <thead>
        <tr>
          <th className="h">LöpNr</th>
          <th>Leverantör</th>
          <th className="h">FakturaNr</th>
          <th>FaktDatum</th>
          <th>FörfDatum</th>
          <th className="h">Att betala</th>
          <th className="h">Moms</th>
          <th>Attesterad</th>
          <th>Godkänd</th>
          <th>Konterad</th>
          <th>Exporterad</th>
        </tr>
      </thead>
      <tbody>
        {props.pageDate && props.pageDate.items.map((value, index) => (
          <tr key={value.id}>
            <td className="h">
              <button type="button" className="btn btn-link" onClick={x => props.clickItem(value)}>{value.id}</button>
            </td>
            <td className="colSupplierName">
              <button type="button" title={`LevId: ${value.supplier?.levId} Namn: ${value.supplier.name}`} className="btn btn-link" onClick={x => props.clickItem(value)}>{value.supplier?.name}</button>
              {/* {value.supplier?.name} */}
            </td>
            <td className="h">
              <button type="button" className="btn btn-link" onClick={x => props.clickItem(value)}>{value.invoiceNr}</button>
            </td>
            <td>
              <FmtDate value={value.invoiceDate} />
            </td>
            <td>
              <FmtDate value={value.dueDate} />
            </td>
            <td className="h">
              <Amount value={value.kapital.kapitalInkl} />
            </td>
            <td className="h">
              <Amount value={value.kapital.moms} />
            </td>
            <td>
              {Atteststatus[value.attesterad]}
            </td>
            <td>
              {Fakturastatus[value.godkand]}
            </td>
            <td>
              {Fakturastatus[value.konterad]}
            </td>
            <td>
              {Exportstatus[value.exporterad]}
            </td>
            {/* <td><Timestamp value={value.created} /></td>
              <td><UserDto value={value.createdBy} /></td> */}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
    ;
}

function getObjectValue(row: SupplierInvoiceRow,  typ: ObjektTyp) {
  if (typ === ObjektTyp.Kst) {
    return row.kst;
  }
  if (typ === ObjektTyp.Prj) {
    return row.proj;
  }
  if (typ === ObjektTyp.Objekt3) {
    return row.objekt3;
  }
  return null;
}

function getAccountNameOrPeriodiseringInfo(value: SupplierInvoiceRow, charts: Charts, konteringsOptions: KonteringsOptions): string {
  if (value.periodisering) {
    var pRad = value.periodisering;
    let result = `P ${pRad.perAntalManader} ${formatDateAsYyyyMmDd(pRad.perStartDatum)} ${pRad.kontoNr} `;

    const objectTypes = [ObjektTyp.Kst, ObjektTyp.Prj, ObjektTyp.Objekt3];
    objectTypes.forEach(objectType => {
      const dim = konteringsOptions?.get(objectType);
      var objectValue = getObjectValue(value, objectType);
      if (dim?.använder && objectValue) {
        result += `${dim?.getShortName()}=${objectValue}`;
      }        
    });
    result += charts?.getKonto(pRad.kontoNr)?.name;
    return result;
  } else {
    return charts?.getKonto(value.kontoNr)?.name;
  }
}

function InvoiceKonteringTable(props: { invoice: SupplierInvoice, clickItem?: (item: SupplierInvoice) => void }) {
  const invoice = props.invoice;
  const konteringsRader = invoice?.konteringsRader;
  // console.log("InvoiceKonteringTable", invoice);

  if (!invoice || !konteringsRader) {
    return null;
  }

  if (konteringsRader.length < 1) {
    return <div>Inga konteringsrader!</div>
  }

  const invoicePageState = useInvoicePageState();
  const charts = useJsRpcPlaner();
  const konteringsOptions = useKonteringsOptions();
  // console.log("konteringsOptions", konteringsOptions);
  const kst = konteringsOptions?.get(ObjektTyp.Kst);
  // console.log("kst", kst);
  const prj = konteringsOptions?.get(ObjektTyp.Prj);
  // console.log("prj", prj);
  const obj3 = konteringsOptions?.get(ObjektTyp.Objekt3);
  const apiSynkaKontering = (konteringSynkSmetaUt: boolean) => api.webSessionUpdate({ cmdType: model.SessionUpdateCmdType.KonteringSynk, fakturaId: invoice.id, konteringSynkSmetaUt: konteringSynkSmetaUt }).then(() => {
    location.reload();
  }).catch((reason) => {
    notifications.dispatchFromError("Fel vid synkning av kontering", reason);
  });
  // console.log("obj3", obj3);
  return <div className="konteringContainer">
    <h4>Kontering</h4>
    <div className="table-responsive invoiceTableDiv">
      <table className="table table-striped table-condensed table-hover table-responsive invoiceKonteringTable">
        <thead>
          <tr>
            <th>Konto</th>
            {kst?.använder &&
              (<th>{kst?.getShortName()}</th>)
            }
            {prj?.använder &&
              (<th>{prj?.getShortName()}</th>)
            }
            {obj3?.använder &&
              (<th>{obj3?.getShortName()}</th>)
            }
            <th>Benämning</th>
            <th className="h">Debet</th>
            <th className="h">Kredit</th>
          </tr>
        </thead>
        <tbody>
          {konteringsRader && konteringsRader.map((value, index) => (
            <tr key={value.radNr}>
              <td>
                {value.kontoNr}
              </td>
              {kst?.använder &&
                <td>
                  {value.kst}
                </td>
              }
              {prj?.använder &&
                <td>
                  {value.proj}
                </td>
              }
              {obj3?.använder &&
                <td>
                  {value.objekt3}
                </td>
              }
              <td className="colKontoNamn">
                {getAccountNameOrPeriodiseringInfo(value, charts, konteringsOptions)}
              </td>
              <td className="h">
                <Amount value={value.value >= 0 ? value.value : 0} />
              </td>
              <td className="h">
                <Amount value={value.value < 0 ? value.value : 0} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
      {invoicePageState?.konteringLockReady && 
      (
        <div className="btn-group" role="group">
        <button type="button" className="btn btn-default" onClick={(e) => {apiSynkaKontering(false)}}>Kopiera kontering</button>
        <button type="button" className="btn btn-default" onClick={(e) => {apiSynkaKontering(true)}}>Kopiera + justera kontering</button>
        </div>
      )
      }
  </div>;
}

// export default HistoryContainer;

function HistoryContainerWrapper(props: IHistoryContainerProps) {
  const [isOpen, setIsOpen] = useState<boolean>(props.isOpen || false);

  console.log("HistoryContainerWrapper", isOpen);

  useEffect(() => {
    if (isOpen) {
      window.$('#react-supplierinvoice-history-container-modal').modal({ show: true }).on('hidden.bs.modal', function () {
        setIsOpen(false);
      })
    }
  }, [isOpen]);

  function openPopup() {
    console.log("openPopup setting to true");
    setIsOpen(true);
  }

  useEffect(() => {
    console.log("use effect in");
    const eventBusMessageReceived = (evt: CustomEvent) => {
      console.log("EventBus got message", evt);
      setIsOpen(true);
    };
    
    window.addEventListener('react-supplierinvoice-history-container-open', eventBusMessageReceived)

    return function cleanup() {
      window.removeEventListener('react-supplierinvoice-history-container-open', eventBusMessageReceived);
    };

  }, []);



  return (
    <>
      {/* <button type="button" className="btn btn-default" onClick={e => openPopup()} >Historiska fakturor</button> */}
      <HistoryContainer isOpen={isOpen} fakturaId={props.fakturaId} supplierId={props.supplierId || 0} />
    </>
  );
}

export default HistoryContainerWrapper;